import{a as e}from"./chunk-F7F43K56.mjs";import{b as m}from"./chunk-TN4M2PHH.mjs";import{h as o,i as r}from"./chunk-CJSGIOWP.mjs";var i=new o({locale:[e,m,r]});export{i as a};
